// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"TableCellButton-primaryButton-25vNwM","cell":"TableCellButton-cell-xxjXsP","button":"TableCellButton-button-1O65Gg"};